import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-checked"]
const _hoisted_2 = ["aria-checked"]

import { computed } from 'vue'

import RecordCard from '@/components/customers/record/RecordCard.vue'
import RecordSettingRow from '@/components/customers/record/RecordSettingRow.vue'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'ProfileCommunication',
  props: {
  conversationUserPairId: { type: String, required: true }
},
  setup(__props) {

const props = __props

const pair = computed(() => mapRelationship({ type: 'conversation_user_pair', id: props.conversationUserPairId }))
const blockingSms = computed(() => pair.value?.attributes?.['do_not_text?'])
const blockingCalls = computed(() => pair.value?.attributes?.['block_calls?'])

const switchClass = on => [
  'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 motion-reduce:transition-none focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
  on ? 'bg-blue-600' : 'bg-gray-200'
]

const knobClass = on => [
  'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 motion-reduce:transition-none',
  on ? 'translate-x-5' : 'translate-x-0'
]

const updatePair = fields =>
  api.call('PUT', `conversation_user_pairs/${props.conversationUserPairId}`, { conversation_user_pair: fields })

const toggleBlockSms = () => updatePair({ do_not_text: blockingSms.value ? 'off' : 'on' })

const toggleBlockCalls = () => updatePair({ block_calls: blockingCalls.value ? 'off' : 'on' })

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(RecordCard, {
    "data-test": "communication-card",
    title: "Communication"
  }, {
    default: _withCtx(() => [
      _createVNode(RecordSettingRow, {
        title: "Block SMS",
        description: "Stops all text messages to this number.",
        "label-id": "block-sms-label"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            role: "switch",
            "data-test": "block-sms",
            "aria-labelledby": "block-sms-label",
            "aria-checked": String(Boolean(blockingSms.value)),
            class: _normalizeClass(switchClass(blockingSms.value)),
            onClick: toggleBlockSms
          }, [
            _createElementVNode("span", {
              "aria-hidden": "true",
              class: _normalizeClass(knobClass(blockingSms.value))
            }, null, 2)
          ], 10, _hoisted_1)
        ]),
        _: 1
      }),
      _createVNode(RecordSettingRow, {
        title: "Block calls",
        description: "Blocks calls to and from this number.",
        "label-id": "block-calls-label"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            role: "switch",
            "data-test": "block-calls",
            "aria-labelledby": "block-calls-label",
            "aria-checked": String(Boolean(blockingCalls.value)),
            class: _normalizeClass(switchClass(blockingCalls.value)),
            onClick: toggleBlockCalls
          }, [
            _createElementVNode("span", {
              "aria-hidden": "true",
              class: _normalizeClass(knobClass(blockingCalls.value))
            }, null, 2)
          ], 10, _hoisted_2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

}